import { e as BarGaugeSizing } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  minVizHeight: 75,
  minVizWidth: 75,
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sizing: BarGaugeSizing.Auto
};

export { defaultOptions, pluginVersion };
